module.exports = __webpack_public_path__ + "static/img/seohan-holdings.93744f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/seohan-holdings.jpg
// module id = e7sw
// module chunks = 0